/**
 * Labstep
 *
 * @module core/Breadcrumb
 */

import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import { Link } from 'labstep-web/core/Link';
import type React from 'react';
import styles from './styles.module.scss';
import type { IBreadcrumbProps } from './types';

export const Breadcrumb: React.FC<IBreadcrumbProps> = ({ links }) => (
  <Flex vAlignContent="center" wrap>
    {links.map((link, i) => (
      <Flex key={link.name} style={{ alignItems: 'baseline' }}>
        {link.route && (
          <Link className={styles.link} {...link.route}>
            {link.icon && <Icon name={link.icon} />}
            {link.name}
          </Link>
        )}
        {!link.route && (
          <>
            {link.icon && <Icon name={link.icon} />}
            {link.name}
          </>
        )}{' '}
        {i < links.length - 1 && (
          <Icon color="grey" name="chevron right" size="small" />
        )}
      </Flex>
    ))}
  </Flex>
);
